import _slicedToArray from "/Users/maas-gcsp/Desktop/Study/sodevly.github.io/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
export function useLocalStorage(key, initialValue) {
  var _React$useState = React.useState(function () {
    try {
      var item = window.localStorage.getItem(key);

      if (item) {
        var test = item.match(/^(\[|\{|\d).*(\]|\}|\d)?$/gm);

        if (test && test.length) {
          return JSON.parse(item);
        } else {
          return item;
        }
      } else {
        return initialValue;
      }
    } catch (error) {
      return initialValue;
    }
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      storedValue = _React$useState2[0],
      setStoredValue = _React$useState2[1];

  var setValue = React.useCallback(function (value) {
    try {
      setStoredValue(value);

      if (typeof value === 'object') {
        window.localStorage.setItem(key, JSON.stringify(value));
      } else {
        window.localStorage.setItem(key, value);
      }
    } catch (error) {
      console.error(error);
    }
  }, [key]);
  return [storedValue, setValue];
}